import {RootState} from '../../store';
import {CustomerSubscription} from './types';

export const selectionSelector = (state: RootState): Record<string, CustomerSubscription> =>
    state['customer-subscriptions'].selection as Record<string, CustomerSubscription>;
